// Import main libraries
import React from 'react';
import ReactDOM from 'react-dom';

// Import styles
// import './index.scss';
// if (process.env.NODE_ENV == "production")
import './styles.bootstrap.prod.scss';
// else
// import './styles.bootstrap.dev.scss';

// Import components
import App from './App';

// Additional
import registerServiceWorker from './registerServiceWorker';

// Setup render
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.jsx